import {
  PurchaseRequestProductRequestBody,
  PurchaseRequestSkuVariantRequestBody,
} from "./PurchaseRequestProductRequestBody";

export interface PurchaseRequestBody {
  vendor_id?: number;
  warehouse_id?: string;
  warehouse_address?: {
    address_line_1: string | null;
    address_line_2: string | null;
    landmark: string | null;
    city: string | null;
    state: string | null;
    pincode: string | null;
    country_code: string | null;
    contact_name: string | null;
    contact_phone: string | null;
    gstin: string | null;
  };
  expected_delivery_date?: Date | string;
  is_urgent_sourcing_request?: boolean;
  urgent_payment_percentage?: number | null;
  pr_products?: PurchaseRequestProductRequestBody[];
  sku_variants?: PurchaseRequestSkuVariantRequestBody[];
  vendor_payment_term?: number;
  subtotal?: number;
  total_tax?: number;
  total_amount?: number;
  city_id?: string;
  city_name?: string;
  warehouse_name?: string;
  vendor_name?: string;
  vendor_email?: string;
  emails?: string[];
  other_charges?: number;
}

export enum PurchaseRequestRejectedBy {
  FINANCE = "FINANCE",
  SOURCING = "SOURCING",
  SWAGEAZY = "SWAGEAZY",
}

export const PurchaseOrderStatusOptions = [
  { id: "OPEN", value: "Open" },
  { id: "CREATED", value: "Created" },
  { id: "CLOSED", value: "Closed" },
  { id: "CANCELLED", value: "Cancelled" },
];
